import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach JWT if present in localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dpc_jwt");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const gid = localStorage.getItem("dpc_guest_id");
  if (gid) {
    config.headers["X-Guest-Id"] = gid;
  }
  return config;
});

export default api;

/** Stable random guest identifier stored in localStorage. */
export function ensureGuestId() {
  let gid = localStorage.getItem("dpc_guest_id");
  if (!gid) {
    gid = `g_${Math.random().toString(36).slice(2, 10)}${Date.now().toString(36)}`;
    localStorage.setItem("dpc_guest_id", gid);
  }
  return gid;
}
